// Checks a given fileIndex in the state for submission ready-ness
export function fileReadyToUpload(file, infoFields) {
  if (!infoFields) {
    return false;
  }

  // Check file is present and has values attr (even if only default empty array)
  if (!file || !file.values) {
    return false;
  }

  // Return false if any of type "checkbox" are required but value is not "1" (indicator for checked)
  if (
    file.values
      .filter((v) => {
        return v.field.required === true && v.field.field_type === 'checkbox';
      })
      .some((v) => {
        return v.value !== '1';
      }) === true
  ) {
    return false;
  }

  return (
    // file ready to upload if all requried fields have corresponding value entry
    infoFields
      .filter((f) => {
        return f.required === true;
      }) // Required fields
      .filter((f) => {
        // Return those without corresponding values entry
        return !file.values
          .filter((v) => {
            return v.value.length !== 0;
          }) // Don't count values with empty value
          .filter((v) => {
            return typeof v.value !== 'string' || v.value.match(/\S/);
          }) // Don't count blank space filled strings, checked by matching against regex
          .some((v) => {
            return f.id === v.field.id;
          });
      }).length === 0
  );
}

// Checks whether or not at least one file is currently uploading
export function fileCurrentlyUploading(files) {
  if (!files) {
    return false;
  }

  return files.some((f) => {
    return f.status === 'Uploading';
  });
}
